export class FileUpload {
  private wrapper: HTMLElement;
  private input: HTMLInputElement;
  private label: HTMLLabelElement;
  private textEl: HTMLElement;
  private originalText: string;
  private form: HTMLFormElement | null;

  constructor(wrapper: HTMLElement) {
    this.wrapper = wrapper;
    this.input = wrapper.querySelector('.file-upload__input') as HTMLInputElement;
    this.label = wrapper.querySelector('.file-upload__label') as HTMLLabelElement;
    this.textEl = wrapper.querySelector('.file-upload__text') as HTMLElement;

    this.originalText = this.textEl.textContent || '';

    // Find parent form (if any)
    this.form = this.wrapper.closest('form');

    this.bindEvents();
  }

  private bindEvents() {
    this.input.addEventListener('change', () => this.handleFile());

    this.label.addEventListener('click', (e) => {
      if (this.wrapper.classList.contains('file-upload--has-file')) {
        e.preventDefault();
        this.removeFile();
      }
    });

    // Handle form reset
    if (this.form) {
      this.form.addEventListener('reset', () => {
        // Allow the browser to reset the input value first
        requestAnimationFrame(() => this.removeFile());
      });
    }
  }

  private handleFile() {
    const file = this.input.files?.[0];
    if (!file) {
      return;
    }

    this.textEl.textContent = file.name;
    this.wrapper.classList.add('file-upload--has-file');
  }

  private removeFile() {
    this.input.value = '';
    this.textEl.textContent = this.originalText;
    this.wrapper.classList.remove('file-upload--has-file');
  }
}
